import React from 'react';
import Me from '../../assets/images/me.jpg'

const MyPhoto = () => {
    return (
        <img src={Me} alt='aungsanoo' className='my-photo round'/>
    );
};

export default MyPhoto;